import React, { useContext } from 'react';
import API from '../../utils/api';
import { SecondaryButton } from '../Buttons/Buttons';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { StoreContext } from '../../utils/store';
const api = new API('http://8.140.23.228');

const LogoutButton = ({ className }) => {
  const history = useHistory();
  const context = useContext(StoreContext);
  const [, setModalStatus] = context.modalStatus;

  const logout = async () => {
    const response = await api.makeAPIRequest('admin/auth/logout', {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
    });
    try {
      if (response.status === 200) {
        localStorage.clear();
        console.log('logout!');
        history.push('/login');
      } else {
        const json = await response.json();
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalHodyText: e.toString(),
        modalColors: 'error',
      }));
    }
  }
  return (
    <SecondaryButton
      label='logout'
      className={className}
      onClick={logout}>
      <span>Log out</span>
    </SecondaryButton>
  );
};

LogoutButton.propTypes = {
  className: PropTypes.string,
};

export default LogoutButton;
